<section class="consejo-directivo mb-5">
  <div class="row m-0 header justify-content-center">
    <h1 class="title">Cursos</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center">
      <!-- Contenido starts -->
      <div class="row" *ngIf="cursos.length && !loading">
        <div class="col-12" *ngFor="let cursoTemp of cursosTemporal">
          <h1 class="mes text-center my-3">{{cursoTemp.mes}} {{cursoTemp.anio}}</h1>

          <!-- Cards Starts -->
          <div class="row equal">
            <div class="col-12 col-md-3 mt-4 mt-md-0" *ngFor="let curso of cursoTemp?.cursosPorMes">
              <mat-card  class="card h-100" [routerLink]="['/cursos', curso.idCurso]">
                <div class="img-container my-2 mx-0">
                  <img mat-card-image [src]="imgTemporal" [alt]="curso.descripcion">
                </div>
                <mat-card-header>
                  <mat-card-title>{{ curso.descripcion }}</mat-card-title>
                  <mat-card-subtitle>
                    Sede: {{ curso.sede }}
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <p>
                    <strong>Fecha de inicio:</strong>
                    {{curso.fechaInicio | date: "mediumDate"}}
                    <br />
                    <strong>Fecha de término:</strong>
                    {{curso.fechaFin | date: "mediumDate"}} <br />
                    <strong>Horario:</strong> De {{curso.horaInicio}} a {{curso.horaFin}}
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <!-- End Cards -->
        </div>
      </div>
      <!--End Contenido-->

      <div class="alert alert-light text-center" *ngIf="loading">
        <p class="d-flex justify-content-center">
          <mat-spinner diameter="80"></mat-spinner>
        </p>
      </div>
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
